<template>
  <div class="cpunk_page with-navbar">
    <rebuild-nav-bar></rebuild-nav-bar>

    <div class="login-container">
      <h2 class="login-title" v-show="!istobind">登陆注册</h2>
      <div class="tab only-desktop" v-show="!istobind">
        <p @click="showlogin(1)" :class="tabIndex == 1 ? 'cur' : ''">手机登录</p>
        <span>|</span>
        <p @click="showlogin(2)" :class="tabIndex == 2 ? 'cur' : ''">微信登录</p>
      </div>
      <div class="tab tobind" v-show="istobind">
        <p class="shadow-title cur">绑定手机</p>
      </div>
      <div class="default-form" v-show="tabIndex == 1">
        <div :class="errors.has('phone') ? 'form-group error' : 'form-group'">
          <label class="form-inner">
            <div class="form-input">
              <input type="tel" name="phone" class="form-control" placeholder="请输入手机号码" v-model="phone" v-validate="'required|phone'" />
              <div class="form-error" v-show="errors.has('phone')">
                {{ errors.first('phone') }}
              </div>
            </div>
          </label>
        </div>

        <div :class="errors.has('smscode') ? 'form-group mt20 error' : 'form-group mt20'">
          <label class="form-inner">
            <div class="form-input">
              <input
                type="text"
                name="smscode"
                class="form-control"
                placeholder="请输入您的验证码"
                maxlength="4"
                v-model="smscode"
                v-validate="'required|alpha_num'"
              />
              <div class="form-error" v-show="errors.has('smscode')">
                {{ errors.first('smscode') }}
              </div>
            </div>
          </label>
          <div class="form-group text-right code-btn-wrapper">
            <button type="button" class="button code-btn" @click="getSmsCode">
              {{ smsBtn.content }}
            </button>
          </div>
        </div>

        <div class="checkbox-label mt20 ml30 protocal-txt">
          <div :class="isProtocolAccepted ? 'checkbox active' : 'checkbox'" @click="protocolToggle"></div>
          <div class="text">
            我已阅读并同意<router-link to="/regulation" class="link" @click.native="trackingAction('yjhbczhucetc', 17)">使用条款</router-link>和<router-link
              to="/protocol"
              class="link"
              @click.native="trackingAction('yjhbczhuceprivacy_policy', 18)"
              >隐私条款</router-link
            >
          </div>
        </div>

        <div class="submit-area text-center">
          <div class="cpunk_btn1" @click="loginSubmit">确认</div>
        </div>

        <div class="wechat-login mt20 only-mobile" v-show="isWeixin && !istobind">
          <p>微信登录</p>
          <img src="@images/rebuild/icon-wechat.png" alt="微信登录" @click="doWeixinAuth" />
        </div>

        <div class="wechat-login mt20 only-mobile" v-show="!isWeixin && !isMobile && !istobind">
          <p>微信登录</p>
          <img src="@images/rebuild/icon-wechat.png" alt="微信登录" @click="showpop = true" />
        </div>
      </div>
      <div class="default-form" v-show="tabIndex == 2">
        <div id="qrcode-login-desktop"></div>
      </div>
    </div>
    <div class="pop-wechat-qrcode" v-show="showpop" @click.stop="showpop = false">
      <div id="qrcode-login"></div>
    </div>

    <page-footer></page-footer>
  </div>
</template>

<script>
import TopBar from '@components/TopBar'
import RebuildNavBar from '@components/RebuildNavBar'
import PageFooter from '@components/PageFooter'
import VideoBg from '@components/VideoBg'
import { mapMutations, mapState } from 'vuex'
import { verify } from '@/utils'
import { behavior } from '@/utils/behavior'

export default {
  name: 'LogIn',
  components: {
    TopBar,
    RebuildNavBar,
    PageFooter,
    VideoBg,
  },
  data() {
    return {
      isMobile: '',
      isProtocolAccepted: false,
      smsBtn: {
        content: '发送验证码',
        countDown: 60,
        canClick: true,
      },
      phone: '',
      smscode: '',
      showpop: false,
      tabIndex: 1,
      isWeixin: false,
      code: '',
      istobind: false,
      _redirect: '',
    }
  },
  computed: {
    ...mapState(['authorization', 'channel', 'campaign', 'access_id', 'activity_id']),
  },
  created() {
    this._redirect = decodeURIComponent(this.$route.query.redirect)
    if (this.authorization) {
      this.$router.push(this._redirect)
    }
  },
  methods: {
    ...mapMutations(['setAuthorization', 'setNickname', 'setMobile', 'setOpenid']),
    protocolToggle() {
      this.isProtocolAccepted = !this.isProtocolAccepted
      _jcq.push(['_track', 'yjhbczhuceagree'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc15' })
    },
    getSmsCode() {
      if (!this.smsBtn.canClick) {
        return false
      }
      this.$validator.validate('phone').then(msg => {
        if (msg) {
          this.smsBtn.canClick = false
          this.$request
            .post(this.$apiConfig.smsUrl, {
              telephone: this.phone,
              type: 2,
            })
            .then(this.handleGetSmsCodeSucc)
        }
      })
    },
    handleGetSmsCodeSucc(res) {
      let resData = res.data
      // console.log(resData)

      if (resData.code == 200007) {
        alert('验证码已发送，请注意查收')
        return false
      }

      if (resData.code == 200011) {
        let regConfirm = confirm('该手机未注册，请先完成注册再登录')
        if (regConfirm == true) {
          this.$router.push('/reg')
        }
        return false
      }

      this.smsBtn.content = this.smsBtn.countDown + 's后重新发送'
      let clock = window.setInterval(() => {
        this.smsBtn.countDown--
        this.smsBtn.content = this.smsBtn.countDown + 's后重新发送'
        if (this.smsBtn.countDown < 0) {
          window.clearInterval(clock)
          this.smsBtn.content = '重新发送验证码'
          this.smsBtn.countDown = 60
          this.smsBtn.canClick = true
        }
      }, 1000)
    },
    doLogin() {
      if (this.isWeixin && this.istobind) {
        //如果是微信登录回来绑定手机号
        this.$request
          .post(this.$apiConfig.wxloginUrl, {
            campaign: this.campaign,
            channel: this.channel,
            telephone: this.phone,
            code: this.smscode,
            unionid: this.unionid,
            openid: this.openid,
            nickname: this.nickname,
            headimgurl: this.headimgurl,
            province: this.province,
            city: this.city,
            sex: this.sex,
            country: this.country,
            language: this.language,
            access_id: this.access_id,
            activity_id: this.activity_id,
          })
          .then(this.handleWXDoLoginSucc)
      } else if (!this.isWeixin && this.istobind) {
        //pc扫码微信登录回来绑定手机号
        this.$request
          .post(this.$apiConfig.pcloginUrl, {
            campaign: this.campaign,
            channel: this.channel,
            telephone: this.phone,
            code: this.smscode,
            unionid: this.unionid,
            openid: this.openid,
            nickname: this.nickname,
            headimgurl: this.headimgurl,
            province: this.province,
            city: this.city,
            sex: this.sex,
            country: this.country,
            language: this.language,
          })
          .then(this.handlePCDoLoginSucc)
      } else {
        this.$request
          .post(this.$apiConfig.loginUrl, {
            campaign: this.campaign,
            channel: this.channel,
            telephone: this.phone,
            code: this.smscode,
            access_id: this.access_id,
            activity_id: this.activity_id,
          })
          .then(this.handleDoLoginSucc)
      }
    },
    handleWXDoLoginSucc(res) {
      let resData = res.data

      if (resData.code == 300001) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300002) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300003) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300004) {
        alert('请输入验证码')
        return false
      }

      if (resData.code == 300005) {
        alert('验证码无效，请重新输入')
        return false
      }
      if (resData.code == 10000) {
        alert('验证码无效，请重新输入')
        return false
      }

      if (resData.code == 300006) {
        alert('验证码过期，请重新获取')
        return false
      }

      // _jcq.push([
      //   '_track',
      //   'Login_Bottom',
      //   {
      //     cellphone: this.phone,
      //   },
      // ])

      this.setAuthorization(resData.data.authorization)
      this.getProfile()

      _jcq.push(['_track', 'yjhbczhuceconfim'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc16' })

      if (!this._.isEmpty(this._redirect)) {
        this.$router.push(this._redirect)
      } else {
        this.$router.push('/fundingnew/index')
      }
    },
    handlePCDoLoginSucc(res) {
      let resData = res.data
      if (resData.code == 300001) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300002) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300003) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300004) {
        alert('请输入验证码')
        return false
      }

      if (resData.code == 300005) {
        alert('验证码无效，请重新输入')
        return false
      }
      if (resData.code == 10000) {
        alert('验证码无效，请重新输入')
        return false
      }

      if (resData.code == 300006) {
        alert('验证码过期，请重新获取')
        return false
      }

      // _jcq.push([
      //   '_track',
      //   'Login_Bottom',
      //   {
      //     cellphone: this.phone,
      //   },
      // ])

      this.setAuthorization(resData.data.authorization)
      _jcq.push(['_track', 'yjhbczhuceconfim'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc16' })
      this.getProfile()
      if (!this._.isEmpty(this._redirect)) {
        this.$router.push(this._redirect)
      } else {
        this.$router.push('/fundingnew/index')
      }
    },
    handleDoLoginSucc(res) {
      let resData = res.data
      if (resData.code == 300001) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300002) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300003) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300004) {
        alert('请输入验证码')
        return false
      }

      if (resData.code == 300005) {
        alert('验证码无效，请重新输入')
        return false
      }
      if (resData.code == 10000) {
        alert('验证码无效，请重新输入')
        return false
      }

      if (resData.code == 300006) {
        alert('验证码过期，请重新获取')
        return false
      }
      this.setAuthorization(resData.data.authorization)
      this.setNickname(resData.data.nickname)
      this.setMobile(resData.data.mobile)
      this.setOpenid(resData.data.openid)
      this.getProfile()

      _jcq.push(['_track', 'yjhbczhuceconfim'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc16' })

      if (!this._.isEmpty(this._redirect)) {
        this.$router.push(this._redirect)
      } else {
        this.$router.push('/fundingnew/index')
      }
    },
    doWeixinAuth() {
      this.$request.post(this.$apiConfig.wxAuthUrl, {}).then(res => {
        if (res.data.code == 0) {
          window.location.href = res.data.data.auth_url
        }
      })
    },
    getWXUserStatus() {
      this.$request
        .post(this.$apiConfig.wxUserInfoUrl, {
          code: this.code,
        })
        .then(res => {
          let data = res.data.data
          console.log(JSON.stringify(data))
          if (data.user_status == 1) {
            //用户已经绑定,
            this.setAuthorization(data.authorization)
            this.getProfile()
            if (!this._.isEmpty(this._redirect)) {
              this.$router.push(this._redirect)
            } else {
              this.$router.push('/fundingnew/index')
            }
          } else {
            //没有绑定,获取数据存起来，等登录一起提交
            // this.setOpenid(data.openid)
            // this.setUnionid(data.unionid)
            // this.setNickname(data.nickname)
            // this.setHeadimgurl(data.headimgurl)
            // this.setProvince(data.province)
            // this.setCity(data.city)
            // this.setCountry(data.country)
            // this.setSex(data.sex)
            // this.setLanguage(data.language)
            this.openid = data.openid
            this.unionid = data.unionid
            this.nickname = data.nickname
            this.headimgurl = data.headimgurl
            this.province = data.province
            this.city = data.city
            this.country = data.country
            this.sex = data.sex
            this.language = data.language
            this.istobind = true
            //alert('请绑定手机号码登录')
          }
        })
    },
    getPCUserStatus() {
      this.$request
        .post(this.$apiConfig.pcUserInfoUrl, {
          code: this.code,
        })
        .then(res => {
          if (res.data.code == 10000) {
            //invalid code

            return
          }
          let data = res.data.data
          console.log(JSON.stringify(data))
          if (data.user_status == 1) {
            //用户已经绑定,
            this.setAuthorization(data.authorization)
            this.getProfile()
            if (!this._.isEmpty(this._redirect)) {
              this.$router.push(this._redirect)
            } else {
              this.$router.push('/fundingnew/index')
            }
          } else {
            //没有绑定,获取数据存起来，等登录一起提交
            // this.setOpenid(data.openid)
            // this.setUnionid(data.unionid)
            // this.setNickname(data.nickname)
            // this.setHeadimgurl(data.headimgurl)
            // this.setProvince(data.province)
            // this.setCity(data.city)
            // this.setCountry(data.country)
            // this.setSex(data.sex)
            // this.setLanguage(data.language)
            this.openid = data.openid
            this.unionid = data.unionid
            this.nickname = data.nickname
            this.headimgurl = data.headimgurl
            this.province = data.province
            this.city = data.city
            this.country = data.country
            this.sex = data.sex
            this.language = data.language
            this.istobind = true
            this.tabIndex = 1
            //alert('请绑定手机号码登录')
          }
        })
    },
    loginSubmit() {
      if (!this.isProtocolAccepted) {
        alert('请阅读并同意使用条款和隐私条款')
        return false
      }

      this.$validator.validateAll().then(msg => {
        // console.log(msg)
        if (msg) {
          // console.log('验证通过')
          this.doLogin()
        }
      })
    },
    trackingAction(action, code) {
      _jcq.push(['_track', action])
      // prc_bhv_abs_bcyjh_bc17  prc_bhv_abs_bcyjh_bc18
      behavior({ behavior_code: `prc_bhv_abs_bcyjh_bc${code}}` })
    },
    showlogin(idx) {
      this.tabIndex = idx
    },
    getProfile: function () {
      this.$request
        .get(this.$apiConfig.myProfile)
        .then(res => {
          const resData = res.data
          if (resData.code == 0 && resData.data) {
            let d = resData.data
            this.setNickname(d.nickname)
            this.setMobile(d.mobile)
          } else {
            console.log(res.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
  mounted() {
    if (verify.isMobile()) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }

    if (verify.isWeixin()) {
      this.isWeixin = true
    } else {
      this.isWeixin = false
    }

    if (this.isWeixin && !this.code) {
      //在微信环境且还没有code
      if (this.$route.query.code) {
        //如果当前url有code，存起来
        this.code = this.$route.query.code
        //获取用户信息
        this.getWXUserStatus()
      }
    }
    if (!this.isWeixin && !this.code) {
      //在pc环境且还没有code
      if (this.$route.query.code) {
        //如果当前url有code，存起来
        this.code = this.$route.query.code
        //获取用户信息
        this.getPCUserStatus()
      }
    }

    if (window.location.hostname == 'absolutnights.cn') {
      var obj = new WxLogin({
        self_redirect: false,
        id: 'qrcode-login',
        //appid: "wx79e907cbc458f0b7", //测试
        appid: 'wx57c3bf3c5a04e162', //正式
        scope: 'snsapi_login',
        redirect_uri: window.location.href,
        //redirect_uri: 'https://absolutnights.cn/new.html',
        state: 'Dd6IL8O9gnYOCCk2FxIWRV5QtVt1KFRlIwfNGiCO',
        style: 'white',
        href: '',
      })

      var obj = new WxLogin({
        self_redirect: false,
        id: 'qrcode-login-desktop',
        //appid: "wx79e907cbc458f0b7", //测试
        appid: 'wx57c3bf3c5a04e162', //正式
        scope: 'snsapi_login',
        redirect_uri: window.location.href,
        //redirect_uri: 'https://absolutnights.cn/new.html',
        state: 'Dd6IL8O9gnYOCCk2FxIWRV5QtVt1KFRlIwfNGiCO',
        style: 'white',
        href: '',
      })
    } else {
      var obj = new WxLogin({
        self_redirect: false,
        id: 'qrcode-login',
        appid: 'wx79e907cbc458f0b7', //测试
        //appid: "wx57c3bf3c5a04e162", //正式
        scope: 'snsapi_login',
        redirect_uri: window.location.href,
        //redirect_uri: 'https://absolutnights.cn/new.html',
        state: 'Dd6IL8O9gnYOCCk2FxIWRV5QtVt1KFRlIwfNGiCO',
        style: 'white',
        href: '',
      })

      var obj = new WxLogin({
        self_redirect: false,
        id: 'qrcode-login-desktop',
        appid: 'wx79e907cbc458f0b7', //测试
        //appid: "wx57c3bf3c5a04e162", //正式
        scope: 'snsapi_login',
        redirect_uri: window.location.href,
        //redirect_uri: 'https://absolutnights.cn/new.html',
        state: 'Dd6IL8O9gnYOCCk2FxIWRV5QtVt1KFRlIwfNGiCO',
        style: 'white',
        href: '',
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.cpunk_page {
  min-height: 100vh;
}
.login-container {
  padding: 60px 30px 30px;
  position: relative;
  .tab {
    margin-bottom: 30px;
    p {
      width: 49%;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      color: nth($green, 3);
      cursor: pointer;
    }
    p.cur {
      color: #fff;
    }
    p:nth-of-type(2) {
      float: right;
    }
    &.tobind {
      p {
        width: 100%;
        font-size: 2.5rem;
      }
    }
  }
  .login-title {
    margin-bottom: 40px;
    text-align: center;
    font-size: $font-lg-b;
    .item {
      margin-right: 40px;
      font-size: $font-lg;
      color: #c4c4c4;
      &.active {
        color: #fff;
        font-weight: 900;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .protocal-txt {
    a {
      color: nth($pink, 1);
    }
  }
  .pink-circle-btn {
    width: 100%;
  }
  .submit-area {
    margin-top: 30px;
  }
  .wechat-login {
    text-align: center;
    img {
      width: 5rem;
    }
  }
  .code-btn-wrapper {
    position: absolute;
    top: 14px;
    right: 20px;
    z-index: 2;
    button {
      padding: 0;
      margin: 0;
      color: nth($pink, 1);
    }
  }
}
.pop-wechat-qrcode {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 3;
  #qrcode-login {
    position: absolute;
    @include center(xy);
  }
}
.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/newLogIn.vue